﻿(function (angular, setTimeout, parseFloat, CSS, ToyotaConsts) {
  "use strict";

  var SESSION_STORAGE_KEY = "finance_calculator_information";

  var DIAL_READY_DELAY_MS = 50;
  var DIAL_WRAPPER_IS_OPEN_DURATION_MS = 1250;
  var DIAL_WRAPPER_TRANSITION_DURATION_MS = 4250;
  var LOADING_TIMEOUT_DURATION_MS = 250;
  var MODAL_SCROLL_DURATION_MS = 250;

  var KMS_INCREMENTS = [10000, 15000, 20000, 30000, 40000, 50000]; // eslint-disable-line no-magic-numbers

  var FRACTION_TO_PERCENT_MULTIPLIER = 100;
  var PERCENT_TO_FRACTION_DIVIDER = 100;

  angular.module("Toyota.Directives").directive("tyFinanceCalculator", function () {
    controller.$inject = [
      "$scope",
      "$rootScope",
      "$filter",
      "$q",
      "API",
      "Range",
      "VehicleService",
      "$timeout",
      "DisclaimersService",
      "SessionStorage",
      "DebugLogger",
      "ToastManager",
      "PricingPageAnalyticsService",
      "PricingSendToDealerAutofill",
    ];
    function controller(
      $scope,
      $rootScope,
      $filter,
      $q,
      API,
      Range,
      VehicleService,
      $timeout,
      DisclaimersService,
      SessionStorage,
      DebugLogger,
      ToastManager,
      PricingPageAnalyticsService,
      PricingSendToDealerAutofill
    ) {
      var ctl = this;
      $scope.financeCalculator = $scope.financeCalculator ? $scope.financeCalculator : {};
      $scope.financeCalculator.calculationUpdated = false;
      $scope.financeCalculator.currentVariable = null;
      $scope.financeCalculator.dialIsDragging = false;
      $scope.financeCalculator.dialSeparators = 16;
      $scope.financeCalculator.dialReady = false;
      $scope.financeCalculator.driveawayPrice = null;
      $scope.financeCalculator.hasError = false;
      $scope.financeCalculator.hasInitialData = false;
      $scope.financeCalculator.isLoaded = false;
      $scope.financeCalculator.isLoading = false;
      $scope.financeCalculator.isFinanceCalculationProcessed = false;
      $scope.financeCalculator.materialCode = null;
      $scope.financeCalculator.previousState = {};
      $scope.financeCalculator.nullStep = {
        difference: 0,
        number: 0,
        name: "",
        gradeId: null,
        displayStep: false,
      };
      $scope.financeCalculator.matchesGradesAPIResults = {};
      $scope.financeCalculator.currentGradeIndex = 0;
      $scope.financeCalculator.steps = [];
      $scope.financeCalculator.disclaimerTitle = "";
      $scope.financeCalculator.variables = {
        loanRate: 0,
        deposit: 0,
        loanTerm: 0,
        kmsPerYear: 0,
      };
      $scope.financeCalculator.calculation = {
        isCampaign: true,
        GFV: null,
        numberOfPayments: 0,
        monthlyPayment: null,
        kmsPerLoanTerm: 0,
      };
      $scope.financeCalculator.hasChanged = {
        loanRate: false,
        deposit: false,
        loanTerm: false,
        kmsPerYear: false,
      };
      $scope.financeCalculator.interactionControl = null;
      $scope.financeCalculator.calculatorOpen = false;

      var calculationResultString = "";
      var loadingTimeout;

      /**
       * isCurrentVariable - Matches if the currently selected variable matches a string
       *
       * @param  {string} current the variable to match
       * @return {boolean} if argument is the current variable
       */
      $scope.financeCalculator.isCurrentVariable = function (current) {
        if ($scope.financeCalculator.currentVariable === null) {
          $scope.financeCalculator.currentVariable = "loanRate";
        }

        return $scope.financeCalculator.currentVariable === current;
      };

      /**
       * setCurrentVariable - Sets the current variable
       *
       * @param  {Event} $event     the source event, used to stop propagation if the vehicle is not
       *                            on campaign and the user hasn't selected an interest rate yet
       * @param  {string} selection the value of the variable i.e. loanRate, kmsPerYear, deposit, or loanTerm
       * @return {void}
       */
      $scope.financeCalculator.setCurrentVariable = function ($event, selection) {
        if (
          $event !== null &&
          $scope.financeCalculator.variableDisabled() &&
          (selection !== "loanRate" || selection !== "")
        ) {
          $event.stopPropagation();
          $event.preventDefault();
          return;
        }

        $scope.financeCalculator.currentVariable = selection;
        $scope.financeCalculator.setDialOptions($scope.financeCalculator.currentVariable);

        $scope.financeCalculator.vehicleModel =
          $scope.tyPricingPage.validVariantIdsForCurrentGrade.grade.vehicleModel.Name;
        $scope.financeCalculator.vehicleDescription =
          $scope.tyPricingPage.validVariantIdsForCurrentGrade.grade.vehicleModel.Name +
          " " +
          $scope.tyPricingPage.validVariantIdsForCurrentGrade.grade.name;
      };

      /**
       * setDialOptions function - sets the dial options for each variable type
       *
       * @param  {string} current the value of the variable i.e. loanRate, kmsPerYear, deposit, or loanTerm
       * @return {void}
       */
      $scope.financeCalculator.setDialOptions = function (current) {
        function calcLoanRate() {
          if ($scope.financeCalculator.variables.loanRate <= 1) {
            return $scope.financeCalculator.variables.loanRate * FRACTION_TO_PERCENT_MULTIPLIER;
          }

          return $scope.financeCalculator.variables.loanRate;
        }

        var dialOptions = {};

        switch (current) {
          case "loanRate":
            if ($scope.financeCalculator.calculation.APR) {
              dialOptions = {
                value: calcLoanRate(),
                min: $scope.financeCalculator.calculation.APR.min,
                max: $scope.financeCalculator.calculation.APR.max,
                startAngle: 90,
                endAngle: "+330",
                step: 0.5,
              };
            }

            break;
          case "deposit":
            dialOptions = {
              value: $scope.financeCalculator.variables.deposit,
              min: 0,
              max: $scope.financeCalculator.calculation.deposit.max,
              startAngle: 90,
              endAngle: "+330",
              step: 50,
            };
            break;
          case "loanTerm":
            dialOptions = {
              value: $scope.financeCalculator.variables.loanTerm,
              min: $scope.financeCalculator.calculation.loanTerm.min,
              max: $scope.financeCalculator.calculation.loanTerm.max,
              startAngle: 90,
              endAngle: "+275",
              step: 1,
            };
            break;
          case "kmsPerYear":
            dialOptions = {
              value: $scope.financeCalculator.variables.kmsPerYearIndex,
              min: 0,
              max: KMS_INCREMENTS.length - 1,
              startAngle: 90,
              endAngle: "+308",
              step: 1,
              customTicks: KMS_INCREMENTS,
            };
            break;
          case "empty":
            dialOptions = {
              value: 45,
              min: 0,
              max: 360,
              startAngle: 0,
              endAngle: "+360",
            };
            break;
          default:
            // same as empty to satisfy linter
            dialOptions = {
              value: 45,
              min: 0,
              max: 360,
              startAngle: 0,
              endAngle: "+360",
            };
        }

        dialOptions.disabled = current === "loanRate" && $scope.financeCalculator.calculation.isCampaign;

        if ($scope.financeCalculator.variableDisabled()) {
          dialOptions.value = null;
          $scope.financeCalculator.dialReady = false;

          if (current !== "loanRate") {
            dialOptions.disabled = true;
          }
        }

        $scope.financeCalculator.initDial(dialOptions);
      };

      /**
       * initDial function - initialises the dial with the options for the current variable
       *
       * @param  {Object} options the dial options object
       * @return {void}
       */
      $scope.financeCalculator.initDial = function (options) {
        var dialOptions = {};
        var baseDialOptions = {
          sliderType: "min-range",
          radius: 133,
          width: 42,
          handleSize: "30",
          tooltipFormat: dialValueDisplay,
          create: dialEvent,
          start: dialEvent,
          stop: dialEvent,
          change: dialEvent,
          drag: dialEvent,
        };

        angular.merge(dialOptions, baseDialOptions, options);

        /*
         * Destroying the roundslider prevents bugs from occuring when switching between slider types
         * For some reason the previous options object was being used the first time a slider is created
         * To replicate this, remove this line and then click through deposit, kms per year, and loan term
         */
        $scope.financeCalculator.dialElement.roundSlider("destroy");
        $scope.financeCalculator.dialElement.roundSlider(dialOptions);
      };

      /**
       * variableDisabled - returns true if the variable control field is disabled
       *                    i.e. the user hasn't selected an interest rate on a non-campaign vehicle first
       *
       * @return {boolean} true if the variable control field is disabled
       */
      $scope.financeCalculator.variableDisabled = function () {
        return (
          !$scope.financeCalculator.calculationUpdated &&
          $scope.financeCalculator.calculation &&
          !$scope.financeCalculator.calculation.isCampaign
        );
      };

      /**
       * closeModal - broadcasts the modal-close event which will be picked up by the modal directive
       *
       * @return {void}
       */
      $scope.closeModal = function () {
        $rootScope.$broadcast("modal-close", "finance-calculator");
      };

      /**
       * track - analytics function
       *
       * @param  {string} action              the event action (e.g. 'button - deposit')
       * @param  {string} label               the event label (e.g. 'deposit $400');
       * @param  {Object} [extraProps]        extra properties to include on the tracking object
       * @return {void}
       */
      $scope.financeCalculator.track = function (action, label, extraProps) {
        if (
          label === "done" ||
          label === "close" ||
          ($scope.financeOptions.showingFinance && $scope.financeCalculator.calculatorOpen)
        ) {
          var analyticsData = angular.extend(
            {},
            { eventCategory: "pricing", eventAction: action, eventLabel: label },
            extraProps
          );
          PricingPageAnalyticsService.triggerAnalytics("gaClick", analyticsData);
        }
      };

      /**
       * setVehicleDescriptionInDisclaimers - replaces placeholder text in the disclaimers with the vehicle description
       *
       * @param  {string} currentdisclaimer the disclaimer
       * @return {string}                   the disclaimer with vehicle description placeholder replaced
       */
      $scope.financeCalculator.setVehicleDescriptionInDisclaimers = function (currentdisclaimer) {
        return currentdisclaimer.replace("{%FullDescription%}", $scope.financeCalculator.vehicleDescription);
      };

      /**
       * setBaseData - the initial call that is made to the API when the user clicks 'calculate finance' on the pricing page
       *
       * @param {object} overrides  object containing options that could include resetVariables, getStepData, campaignTypeDidChange, ignoreSessionVariables
       * @return {void}
       */
      $scope.financeCalculator.setBaseData = function (overrides) {
        var config = {
          resetVariables: true,
          getStepData: false,
          campaignTypeDidChange: false,
          ignoreSessionVariables: false,
        };

        angular.extend(config, overrides);

        if (
          config.campaignTypeDidChange ||
          config.getStepData ||
          didMaterialCodeChange() ||
          didDriveawayPriceChange() ||
          didLocationChange()
        ) {
          $scope.financeCalculator.vehicleModel =
            $scope.tyPricingPage.validVariantIdsForCurrentGrade.grade.vehicleModel.Name;
          $scope.financeCalculator.gradeName = $scope.tyPricingPage.validVariantIdsForCurrentGrade.grade.name;
          $scope.financeCalculator.vehicleDescription =
            $scope.financeCalculator.vehicleModel + " " + $scope.financeCalculator.gradeName;

          $scope.financeCalculator.lastMaterialCode = $scope.financeCalculator.materialCode;
          $scope.financeCalculator.lastIsCampaign = $scope.financeCalculator.calculation.isCampaign;

          $scope.financeCalculator.materialCode = $scope.materialCode;
          $scope.financeCalculator.driveawayPrice = $scope.driveawayPrice.price;
          $scope.financeCalculator.postcode = $scope.driveawayPrice.postcode;
          $scope.financeCalculator.suburb = $scope.driveawayPrice.suburb;
          $scope.financeCalculator.state = $scope.driveawayPrice.state;
          $scope.financeCalculator.region = $scope.driveawayPrice.region;

          var updateVehiclesPostData = false;
          var sessionVariables = getSessionStorage();
          var doesSessionModelMatch =
            sessionVariables !== null && $scope.financeCalculator.vehicleModel === sessionVariables.vehicleModel;

          if (sessionVariables !== null && !config.ignoreSessionVariables && doesSessionModelMatch) {
            $scope.financeCalculator.calculationUpdated = true;
            $scope.financeCalculator.dialReady = true;

            $scope.financeCalculator.variables.loanRate = sessionVariables.loanRate;
            $scope.financeCalculator.variables.deposit = sessionVariables.deposit;
            $scope.financeCalculator.variables.loanTerm = sessionVariables.loanTerm;
            $scope.financeCalculator.variables.kmsPerYear = sessionVariables.kmsPerYear;

            updateVehiclesPostData = true;
          } else if (
            config.resetVariables ||
            (!config.getStepData && !$scope.financeCalculator.calculationUpdated) ||
            (sessionVariables && !doesSessionModelMatch)
          ) {
            if (config.resetVariables) {
              $scope.financeCalculator.calculationUpdated = false;
            }

            $scope.financeCalculator.variables.loanRate = 0;
            $scope.financeCalculator.variables.deposit = 0;
            $scope.financeCalculator.variables.loanTerm = 0;
            $scope.financeCalculator.variables.kmsPerYear = 0;
          }

          if (config.campaignTypeDidChange) {
            $scope.financeCalculator.hasChanged = {
              loanRate: false,
              deposit: false,
              loanTerm: false,
              kmsPerYear: false,
            };
          }

          if (config.getStepData) {
            $scope.financeCalculator.steps = [];
          }

          setVehiclesPostData(updateVehiclesPostData, config.getStepData);
        } else {
          resetLoading();
        }
      };

      /**
       * hasStepOptions - returns true if there are step up/step down options available
       *
       * @return {boolean}  description
       */
      $scope.financeCalculator.hasStepOptions = function () {
        return $scope.financeCalculator.steps.length > 0;
      };

      /**
       * switchToGrade - switches the calculator context to a different vehicle grade and closes the modal
       *
       * @param  {Object} step the step object
       * @return {void}
       */
      $scope.financeCalculator.switchToGrade = function (step) {
        var extraProps = {
          switchNow: "$" + step.difference + "/wk",
          grade: step.gradeName,
          calcComplete: 1,
          calcInteraction: 0,
        };

        Range.getVariantByMaterialCode(step.MaterialCode).then(function (result) {
          var variantOptions = result;

          // Broadcast variant options to pricing-variant-selector
          $rootScope.$broadcast("update-variant-options", variantOptions);

          // Update the GFV and price per week for analytics
          $scope.financeCalculator.calculation.GFV = step.gfv;
          $scope.financeCalculator.calculation.pricePerWeek = step.pricePerWeek;

          // Track the interaction
          $scope.financeCalculator.track("button - explore options", "Switch to the " + step.name, extraProps);

          // Broadcast grade change to pricing-grade-selector
          $rootScope.$broadcast("grade-change", step.gradeId);
          // Close the modal
          $scope.closeModal();
        });
      };

      // EVENTS
      $scope.$on("modal-close", function (event, target) {
        if (target === "finance-calculator") {
          $scope.financeCalculator.calculatorOpen = false;
          $scope.financeCalculator.dialWrapper.removeClass("is-open");
          $scope.financeCalculator.dialWrapper.removeClass("has-transition");
        }
      });

      $scope.$on("modal-open", function (event, modalId) {
        if (modalId === "finance-calculator") {
          $scope.financeCalculator.calculatorOpen = true;
          $scope.financeCalculator.modalState = "loading";
          $scope.financeCalculator.setCurrentVariable(null, "loanRate");
          if ($scope.financeCalculator.calculation.isCampaign) {
            $scope.financeCalculator.isLoading = true;
            $scope.financeCalculator.setBaseData({
              resetVariables: false,
              getStepData: true,
            });
          }

          if ($scope.financeCalculator.variableDisabled()) {
            $scope.financeCalculator.dialWrapper.addClass("is-open");
            $scope.financeCalculator.dialWrapper.addClass("has-transition");
            setTimeout(function () {
              $scope.financeCalculator.dialWrapper.removeClass("is-open");
            }, DIAL_WRAPPER_IS_OPEN_DURATION_MS);
            setTimeout(function () {
              $scope.financeCalculator.dialWrapper.removeClass("has-transition");
            }, DIAL_WRAPPER_TRANSITION_DURATION_MS);
          }
        }
      });

      $scope.$on("grade-changed", function () {
        $scope.financeCalculator.isLoaded = true;
      });

      $scope.$on("variant-changed", function () {
        $scope.financeCalculator.isLoading = true;
      });

      $scope.$watch("materialCode", function () {
        $scope.financeCalculator.isLoaded = false;
      });

      $scope.$watch(
        "driveawayPrice",
        function (newValue, oldValue) {
          if (newValue !== oldValue && !newValue.loading && $scope.financeCalculator.hasInitialData) {
            if (didDriveawayPriceChange() || didLocationChange()) {
              $scope.financeCalculator.isLoaded = false;
              $scope.financeCalculator.setBaseData({ resetVariables: false });
            } else {
              resetLoading();
            }
          }
        },
        true
      );

      // PRIVATE FUNCTIONS

      /**
       * didLocationChange - returns true if the location from driveawayPrice and financeCalculator do not match
       *
       * @return {boolean} true if location has changed
       */
      function didLocationChange() {
        return (
          $scope.financeCalculator.postcode !== $scope.driveawayPrice.postcode ||
          $scope.financeCalculator.suburb !== $scope.driveawayPrice.suburb ||
          $scope.financeCalculator.region !== $scope.driveawayPrice.region
        );
      }

      /**
       * didMaterialCodeChange - returns true if the material code from $scope and financeCalculator do not match
       *
       * @return {boolean} true if materialCode has changed
       */
      function didMaterialCodeChange() {
        return $scope.financeCalculator.materialCode !== $scope.materialCode;
      }

      /**
       * didDriveawayPriceChange - returns true if the price from driveawayPrice and financeCalculator do not match
       *
       * @return {boolean} true if driveawayPrice has changed
       */
      function didDriveawayPriceChange() {
        return $scope.financeCalculator.driveawayPrice !== $scope.driveawayPrice.price;
      }

      /**
       * hasVariableChanged - returns true if a variable value has changed
       *
       * @param  {string} key   the variable name i.e. loanRate, kmsPerYear, deposit, or loanTerm
       * @param  {string} value the value to test
       * @return {boolean} true if variable value has changed
       */
      function hasVariableChanged(key, value) {
        return $scope.financeCalculator.variables[key] !== value;
      }

      /**
       * setVariableValueFromDial - updates the variable value from the dial
       *
       * @param  {string} percentValue            the value from the dial
       * @param  {boolean} shouldUpdateAPI if true, the API should be called to get a calculation - only true if the value of a control field changes
       * @return {void}
       */
      function setVariableValueFromDial(percentValue, shouldUpdateAPI) {
        var normalisedValue = percentValue / PERCENT_TO_FRACTION_DIVIDER;
        switch ($scope.financeCalculator.currentVariable) {
          case "loanRate":
            $scope.financeCalculator.hasChanged.loanRate = hasVariableChanged("loanRate", normalisedValue);
            $scope.financeCalculator.variables.loanRate = normalisedValue;
            break;
          case "deposit":
            $scope.financeCalculator.hasChanged.deposit = hasVariableChanged("deposit", percentValue);
            $scope.financeCalculator.variables.deposit = percentValue;
            break;
          case "loanTerm":
            $scope.financeCalculator.hasChanged.loanTerm = hasVariableChanged("loanTerm", percentValue);
            $scope.financeCalculator.variables.loanTerm = percentValue;
            break;
          case "kmsPerYear":
            $scope.financeCalculator.hasChanged.kmsPerYear = hasVariableChanged("kmsPerYearIndex", percentValue);
            $scope.financeCalculator.variables.kmsPerYearIndex = percentValue;
            $scope.financeCalculator.variables.kmsPerYear = KMS_INCREMENTS[percentValue];
            break;
          default:
        }

        $scope.$apply();

        if (shouldUpdateAPI) {
          setVehiclesPostData(shouldUpdateAPI, true);
        }
      }

      /**
       * dialEvent - event handler for interactions with the dial. valid events are click, drag, start, and stop
       *
       * @param  {Event} e the source event
       * @return {void}
       */
      function dialEvent(e) {
        var shouldUpdateAPI = false;
        var shouldReInitDial = !$scope.financeCalculator.dialReady;

        if (e.type === "create" && $scope.financeCalculator.hasInitialData) {
          setTimeout(function () {
            $scope.financeCalculator.dialReady = true;
          }, DIAL_READY_DELAY_MS);
        }

        // Change means the current value is different to the previous value
        if (e.type === "change") {
          shouldUpdateAPI = true;
          resetErrorVariable();
        }

        if (e.type === "start") {
          $scope.financeCalculator.dialIsDragging = true;
          angular.element(".rs-input").blur();
        }

        if (e.type === "stop") {
          $scope.financeCalculator.dialIsDragging = false;
        }

        // This event is triggered when the dial is rendered
        if (e.type !== "create") {
          setVariableValueFromDial(e.value, shouldUpdateAPI);
        }

        if (shouldReInitDial) {
          $scope.financeCalculator.initDial(e.options);
        }
      }

      /**
       * dialValueDisplay - returns a formatted value for the dial
       *
       * @param  {Object} args the tooltip
       * @return {string} formatted value for dial display
       */
      function dialValueDisplay(args) {
        var value = args.value;

        if ($scope.financeCalculator.calculation) {
          switch ($scope.financeCalculator.currentVariable) {
            case "deposit":
              value = $filter("formatPrice")(value).replace("$", "");
              break;
            case "loanRate":
              value = $filter("formatPercentage")(value / PERCENT_TO_FRACTION_DIVIDER, 2).replace("%", "");
              break;
            case "kmsPerYear":
              value = $filter("formatNumber")(value);
              break;
            default:
          }

          if (!$scope.financeCalculator.calculation.isCampaign) {
            value =
              $scope.financeCalculator.dialReady &&
              (args.options.enteredValue !== "" || $scope.financeCalculator.calculationUpdated)
                ? value
                : "- -";
          }
        }

        return value;
      }

      /**
       * getCurrentVariableValueFormatted - returns the formatted value of the current variable (e.g. 20,000km, 1.49%)
       *
       * @return {string} formatted current variable value
       */
      function getCurrentVariableValueFormatted() {
        if ($scope.financeCalculator.currentVariable === "deposit") {
          return $scope.financeCalculator.variables[$scope.financeCalculator.currentVariable];
        }

        return $scope.financeCalculator.variables[$scope.financeCalculator.currentVariable + "Formatted"];
      }

      /**
       * handleError - set variables when an error occurs
       *
       * @return {void}
       */
      function handleError() {
        $scope.financeCalculator.calculation.showPricePerWeekAndGFV = false;
        $scope.financeCalculator.hasError = true;
        $scope.financeCalculator.errorVariable = $scope.financeCalculator.currentVariable;
      }

      /**
       * resetErrorVariable - sets the errorVariable to null
       *
       * @return {void}
       */
      function resetErrorVariable() {
        $scope.financeCalculator.errorVariable = null;
      }

      /**
       * resetLoading - resets the loading overlay
       *
       * @return {void}
       */
      function resetLoading() {
        clearTimeout(loadingTimeout);

        $scope.financeCalculator.isLoading = false;
        $scope.financeCalculator.isLoaded = true;
      }

      /**
       * applySpecialOffers - determines special offer from driveaway price for step up and down vehicles
       *
       * @param  {array} specialOffers array of special offers from driveaway price call.
       * @param {number} driveawayPrice  current drive away price of vehicle
       * @return {number} driveaway price or special offer price where applicable
       */
      function applySpecialOffers(specialOffers, driveawayPrice) {
        var price = parseFloat(driveawayPrice);

        if (specialOffers && specialOffers.length) {
          var nowDateMs = new Date();
          nowDateMs.setHours(0, 0, 0, 0); // i.e. ignore time portion of date
          nowDateMs = nowDateMs.getTime();

          var validSpecialOffers = specialOffers.filter(function (specialOffer) {
            return (
              (specialOffer.Region.indexOf("ALL REGIONS") >= 0 ||
                specialOffer.Region.toString().indexOf($scope.financeCalculator.region) >= 0) &&
              specialOffer.IsVisibleOnPricingPage
            );
          });

          if (validSpecialOffers.length) {
            var specialOffer = validSpecialOffers[0];

            if (
              !specialOffer.IsNonPriceOffer &&
              specialOffer.ShouldOverrideOfferPrice &&
              specialOffer.TotalPrice &&
              specialOffer.TotalPrice !== "0"
            ) {
              price = parseFloat(specialOffer.TotalPrice);
            }
          }
        }

        return price;
      }

      /**
       * constructVehicleData - builds the vehicles data object based on current material code
       *
       * @param  {string} currentMaterialCode   the material code of the currently selected vehicle
       * @param  {number} driveawayPrice        driveaway price of the currently selected vehicle
       * @param  {string} postcode              postcode set by the customer
       * @return {promise}                      promise with array of vehicle data
       */
      function constructVehicleData(currentMaterialCode, driveawayPrice, postcode) {
        var currentVehicleData = {
          materialCode: currentMaterialCode,
          driveawayPrice: driveawayPrice,
        };

        var promises = [0, -1, 1].map(function (step) {
          if (step === 0) {
            return currentVehicleData;
          }

          return VehicleService.getMaterialCodeByAdjacentGradeMaterialCode(currentMaterialCode, step)
            .then(function (result) {
              if (!result || typeof result.MaterialCode === "undefined" || result.MaterialCode === "") {
                return null;
              }

              return result.MaterialCode;
            })
            .then(function (stepMaterialCode) {
              if (stepMaterialCode === null) {
                return null;
              }

              return Range.getPricingOptionsAndSpecialOffersByMaterialCode(stepMaterialCode, {
                postcode: postcode,
              }).then(
                function (response) {
                  if (response && response.pricingOptions) {
                    var stepPrice = applySpecialOffers(response.specialOffers, response.pricingOptions.Driveaway_Price);

                    return {
                      materialCode: stepMaterialCode,
                      driveawayPrice: stepPrice,
                    };
                  }

                  DebugLogger.log(
                    "tyFinanceCalculator",
                    "getPricincOptionsAndSpecialOffersByMaterialCode for adjacent vehicle",
                    "driveawayPrice or driveawayPrice.pricingOptions is null"
                  );
                  return null;
                },
                function (error) {
                  DebugLogger.log(
                    "tyFinanceCalculator",
                    "getPricincOptionsAndSpecialOffersByMaterialCode for adjacent vehicle",
                    error
                  );
                  return {};
                }
              );
            });
        });

        return $q.all(promises);
      }

      /**
       * setVehiclesPostData - constructs post data of vehicles and calls fetchAndProcessFinanceCalculation
       *
       * @param  {boolean} isUpdate determines if the API should be called to initialize data or update current settings.
       * @param {boolean} getStepData  determines if we include additional vehicles in the vehicle data
       * @return {void}
       */
      function setVehiclesPostData(isUpdate, getStepData) {
        /* eslint-disable no-param-reassign */
        isUpdate = typeof isUpdate === "undefined" ? false : isUpdate;
        getStepData = typeof getStepData === "undefined" ? false : getStepData;
        /* eslint-enable no-param-reassign */

        var vehiclesData = [
          {
            Driveaway: $scope.financeCalculator.driveawayPrice,
            MaterialCode: $scope.financeCalculator.materialCode,
          },
        ];

        var financeSettings = {
          AgreedInterestRatePa: $scope.financeCalculator.variables.loanRate * FRACTION_TO_PERCENT_MULTIPLIER,
          Deposit: $scope.financeCalculator.variables.deposit,
          TermInYears: $scope.financeCalculator.variables.loanTerm,
          KmsPerYear: $scope.financeCalculator.variables.kmsPerYear,
          LoanType: 1,
          IsFirstLoad: false,
        };

        if (isUpdate) {
          $scope.financeCalculator.calculationUpdated = true;

          vehiclesData = vehiclesData.map(function (vehicle) {
            return angular.extend({}, vehicle, { FinanceSettings: financeSettings });
          });
        }

        var postData = {
          Vehicles: vehiclesData,
          Region: $scope.financeCalculator.region,
          Postcode: $scope.financeCalculator.postcode,
          Suburb: $scope.financeCalculator.suburb,
        };

        if (getStepData && $scope.financeCalculator.calculation.isCampaign) {
          var vehiclesPromise = constructVehicleData(
            $scope.financeCalculator.materialCode,
            $scope.financeCalculator.driveawayPrice,
            $scope.financeCalculator.postcode
          );

          vehiclesPromise.then(function (_vehicles) {
            var vehicles = _vehicles
              .map(function (vehicle) {
                if (!vehicle) {
                  return null;
                }

                return {
                  Driveaway: vehicle.driveawayPrice,
                  MaterialCode: vehicle.materialCode,
                };
              })
              .filter(function (vehicle) {
                return !!vehicle;
              });

            if (isUpdate) {
              vehicles = vehicles.map(function (vehicle) {
                return angular.extend({}, vehicle, { FinanceSettings: financeSettings });
              });
            }

            postData = {
              Vehicles: vehicles,
              Region: $scope.financeCalculator.region,
              Postcode: $scope.financeCalculator.postcode,
              Suburb: $scope.financeCalculator.suburb,
            };

            fetchAndProcessFinanceCalculation(postData);
          });
        } else {
          fetchAndProcessFinanceCalculation(postData);
        }
      }

      /**
       * fetchAndProcessFinanceCalculation - calls the FinanceCalculator API and displays data or error states.
       *
       * @param  {type} postData object with location, vehicle data and finance settings
       * @return {void}
       */
      function fetchAndProcessFinanceCalculation(postData) {
        $scope.financeCalculator.isLoaded = false;

        loadingTimeout = $timeout(function () {
          if (!$scope.financeCalculator.isLoaded) {
            $scope.financeCalculator.isLoading = true;
          }
        }, LOADING_TIMEOUT_DURATION_MS);

        return API.post(ToyotaConsts.API.Finance.FinanceCalculation, postData).then(
          function (response) {
            var result = response.data.CalculationResults[0];
            var steps = response.data.StepUps;
            var results = response.data.CalculationResults;
            var err = response.data.Errors;
            var hasErrors = err?.length > 0 || result?.ErrorCode !== null;

            if (hasErrors) {
              handleError();

              $scope.financeCalculator.track(
                "error - " + $scope.financeCalculator.currentVariable,
                getCurrentVariableValueFormatted(),
                {
                  errorCode: result?.ErrorCode?.ErrorCode,
                  errorMessage: result?.ErrorCode?.ErrorText,
                }
              );

              $scope.financeCalculator.isFinanceCalculationProcessed = true;
            } else {
              var sessionVariables = getSessionStorage();
              var CampaignNoMatch =
                $scope.financeCalculator.hasInitialData &&
                $scope.financeCalculator.calculation.isCampaign !== result.Settings.IsCampaign;
              var sessionCampaignNoMatch =
                sessionVariables !== null && sessionVariables.isCampaign !== result.Settings.IsCampaign;

              if (CampaignNoMatch || sessionCampaignNoMatch) {
                calculationResultString = "";
                removeSessionStorage();
                if (!$scope.financeCalculator.calculation.isCampaign) {
                  var shouldShowGFV = true;
                  $scope.financeOptions.toggleGFV(shouldShowGFV);
                }

                $scope.financeCalculator.calculation.isCampaign = result.Settings.IsCampaign;
                $scope.financeCalculator.setBaseData({
                  resetVariables: true,
                  getStepData: false,
                  campaignTypeDidChange: true,
                  ignoreSessionVariables: true,
                });

                return null;
              }

              var resultString = JSON.stringify(result);

              if (!$scope.financeCalculator.calculationUpdated || calculationResultString !== resultString) {
                calculationResultString = resultString;
                parseAndDisplayCalculationResponse(result);
              }

              parseAndDisplayStepUpResponse(steps, results);

              if ($scope.financeCalculator.interactionControl) {
                $scope.financeCalculator.track(
                  $scope.financeCalculator.interactionControl + " - " + $scope.financeCalculator.currentVariable,
                  getCurrentVariableValueFormatted()
                );
              }

              $scope.financeCalculator.isFinanceCalculationProcessed = true;

              return null;
            }

            resetLoading();
            return undefined;
          },
          // XHR/HTTP error handler
          function (response) {
            handleError();
            resetLoading();

            $scope.financeCalculator.track(
              "error - " + $scope.financeCalculator.currentVariable,
              getCurrentVariableValueFormatted(),
              {
                errorCode: response.status,
                errorMessage: response.reason,
              }
            );
          }
        );
      }

      /**
       * parseAndDisplayCalculationResponse - parses the response from the API for the currently selected vehicle and the finance settings
       *
       * @param  {object} result  the API response with currently selected vehicle data
       * @return {void}
       */
      function parseAndDisplayCalculationResponse(result) {
        $scope.financeCalculator.hasInitialData = true;
        var previousGfv = $scope.financeCalculator.calculation.GFV;

        $scope.financeCalculator.calculation = {
          hasGFV: !isNaN(result.GFV),
          hasResult: result.Settings.IsCampaign || result.WasFinanced,
          isCampaign: result.Settings.IsCampaign,
          comparisonRate: result.ComparisonRatePercentage
            ? result.ComparisonRatePercentage / PERCENT_TO_FRACTION_DIVIDER
            : 0,
          GFV: Math.ceil(result.GFV),
          kmsPerLoanTerm: result.Settings.KmsPerYear * result.Settings.TermInYears,
          numberOfPayments: result.NumberOfPayments,
          monthlyPayment: Math.ceil(result.MonthlyPaymentAmountWithCents),
          campaignLabel: result.Settings.CampaignLabel,
          campaignType: result.Settings.CampaignType,
          disclaimers: result.Disclaimers,
          pricePerWeek: result.PricePerWeek,
          showPricePerWeekAndGFV: true,
          deposit: {
            default: result.Settings.Deposit,
            adjusted: result.Settings.AdjustedDeposit,
            max: result.Settings.MaximumDeposit,
          },
          kmsPerYear: {
            default: result.Settings.KmsPerYear,
            min: result.Settings.MinKmsPerYear,
            max: result.Settings.MaxKmsPerYear,
          },
          loanTerm: {
            default: result.Settings.TermInYears,
            min: result.Settings.MinTermInYears,
            max: result.Settings.MaxTermInYears,
          },
          APR: {
            default: result.Settings.AgreedInterestRatePa
              ? result.Settings.AgreedInterestRatePa / PERCENT_TO_FRACTION_DIVIDER
              : result.Settings.MinimumAPR / PERCENT_TO_FRACTION_DIVIDER,
            min: result.Settings.MinimumAPR,
            max: result.Settings.MaximumAPR,
          },
          errorCode: result?.ErrorCode,
        };

        if (result.Settings.IsCampaign) {
          $scope.financeCalculator.variables.loanRate = $scope.financeCalculator.calculation.comparisonRate;
        } else {
          $scope.financeCalculator.variables.loanRate = $scope.financeCalculator.calculation.APR.default;
        }

        $scope.financeCalculator.hasError = Boolean($scope.financeCalculator.calculation?.errorCode || false);

        // Set defaults
        $scope.financeCalculator.variables.deposit = $scope.financeCalculator.calculation.deposit.default;
        $scope.financeCalculator.variables.loanTerm = $scope.financeCalculator.calculation.loanTerm.default;
        $scope.financeCalculator.variables.kmsPerYear = $scope.financeCalculator.calculation.kmsPerYear.default;
        $scope.financeCalculator.variables.kmsPerYearIndex = KMS_INCREMENTS.indexOf(
          $scope.financeCalculator.variables.kmsPerYear || 0
        );
        $scope.financeCalculator.variables.depositFormatted = "$ - -";
        $scope.financeCalculator.variables.loanTermFormatted = "- - yr";
        $scope.financeCalculator.variables.kmsPerYearFormatted = "- - km";
        $scope.financeCalculator.variables.loanRateFormatted = "- - %";

        // Formatted variables
        if ($scope.financeCalculator.calculation.hasResult) {
          $scope.financeCalculator.variables.depositFormatted = $filter("formatPrice")(
            $scope.financeCalculator.variables.deposit
          );
          $scope.financeCalculator.variables.loanTermFormatted = $scope.financeCalculator.variables.loanTerm + " yr";
          $scope.financeCalculator.variables.kmsPerYearFormatted =
            $filter("formatNumber")($scope.financeCalculator.variables.kmsPerYear) + " km";
          $scope.financeCalculator.variables.loanRateFormatted = $filter("formatPercentage")(
            $scope.financeCalculator.variables.loanRate,
            2
          );
        }

        if ($scope.financeCalculator.calculationUpdated) {
          updateSessionStorage(
            $scope.financeCalculator.vehicleModel,
            $scope.financeCalculator.variables.loanRate,
            $scope.financeCalculator.variables.deposit,
            $scope.financeCalculator.variables.loanTerm,
            $scope.financeCalculator.variables.kmsPerYear,
            $scope.financeCalculator.calculation.isCampaign
          );
        }

        if (
          previousGfv !== null &&
          $scope.financeCalculator.calculation.GFV !== previousGfv &&
          ($scope.financeCalculator.calculationUpdated || $scope.financeCalculator.calculation.isCampaign)
        ) {
          triggerGfvChangeNotification();
        } else if (!$scope.financeCalculator.calculationUpdated && !$scope.financeCalculator.calculation.isCampaign) {
          /*
           * Setting the GFV to null to ensure that if the guest moves to another grade without interacting with the
           * finance calculator, a toast is not shown.
           */
          $scope.financeCalculator.calculation.GFV = null;
          $scope.financeCalculator.calculation.numberOfPayments = 0;
          $scope.financeCalculator.calculation.monthlyPayment = null;
          $scope.financeCalculator.calculation.kmsPerLoanTerm = 0;
        }

        exportFinanceDisclaimers($scope.financeCalculator.calculation.disclaimers);

        PricingPageAnalyticsService.setFinanceOptions({
          estimatedRepayments: $scope.financeCalculator.calculation.pricePerWeek,
          interestRate: $scope.financeCalculator.variables.loanRateFormatted,
          loanTerm: $scope.financeCalculator.variables.loanTermFormatted,
          deposit: $scope.financeCalculator.variables.deposit,
          avgDistance: $scope.financeCalculator.variables.kmsPerYearFormatted,
          gfv: $scope.financeCalculator.calculation.GFV,
        });

        PricingSendToDealerAutofill.updateFinanceDetails(
          {
            messageTemplate: ctl.messageTemplate,
            variantName: $scope.pricingPage.variantName,
            materialCode: $scope.financeCalculator.materialCode,
            pricePerWeek: $scope.financeCalculator.calculation.pricePerWeek,
            loanRate: $scope.financeCalculator.variables.loanRate,
            loanTerm: $scope.financeCalculator.variables.loanTerm,
            gfv: $scope.financeCalculator.calculation.GFV,
            deposit: $scope.financeCalculator.variables.deposit,
            kmsPerYear: $scope.financeCalculator.variables.kmsPerYear,
            disclaimers: parseDisclaimersToSitecoreSchema($scope.financeCalculator.calculation.disclaimers),
          },
          PricingPageAnalyticsService.getAllVehicleData()
        );

        if ($scope.financeCalculator.modalState === "loading") {
          $scope.financeCalculator.modalState = "done";
          $scope.financeCalculator.setCurrentVariable(null, $scope.financeCalculator.currentVariable);
        }

        resetLoading();
      }

      /**
       * triggerGfvToast - Trigger a toast to inform the guest that the GFV has changed due to a vehicle configuration change
       * @return {void}
       */
      function triggerGfvChangeNotification() {
        if (
          !$scope.financeCalculator.calculatorOpen &&
          $scope.pricingPage.stickyFooterVisible &&
          $scope.financeOptions.isGFVHidden
        ) {
          // Remove any previous GFV change notifications and then trigger a new toast
          ToastManager.removeToastsByGroup("gfv-changed");
          ToastManager.triggerForeverToast($scope.financeOptions.gfvToastMessage, "gfv-changed", true);
        }

        if ($scope.financeCalculator.calculatorOpen) {
          // Remove any previous GFV change notifications when the calculator is open
          ToastManager.removeToastsByGroup("gfv-changed");
        }
      }

      /**
       * parseAndDisplayStepUpResponse - parses the response from the API for the adjacent vehicles primarily the GFV and weekly price
       *
       * @param  {object} stepData        the step data for all adjacent vehicles
       * @param  {object} calculationData financial calculations for all adjacent vehicles
       * @return {void}
       */
      function parseAndDisplayStepUpResponse(stepData, calculationData) {
        var currentVehicle = {};

        $scope.financeCalculator.matchesGradesAPIResults = {};

        calculationData.forEach(function (grade) {
          var simplifiedGrade = {
            materialCode: grade.Vehicle.MaterialCode,
            isCampaign: grade.Settings.IsCampaign,
            WeeklyAmount: grade.PricePerWeek,
          };

          $scope.financeCalculator.matchesGradesAPIResults[grade.Vehicle.MaterialCode] = simplifiedGrade;
        });

        if (stepData.length > 0) {
          currentVehicle = $scope.financeCalculator.matchesGradesAPIResults[calculationData[0].Vehicle.MaterialCode];

          var reducedStepData = stepData
            .map(function (step) {
              if (step.MaterialCode === $scope.financeCalculator.materialCode) {
                currentVehicle = step;
                return null;
              }

              return step;
            })
            .filter(function (step) {
              return !!step;
            });

          var modifiedStepData = reducedStepData.map(function (step) {
            var difference = step.WeeklyAmount - currentVehicle.WeeklyAmount;
            return Range.getGradeIdByMaterialCode(step.MaterialCode)
              .then(function (gradeId) {
                return gradeId;
              })
              .then(function (gradeId) {
                var grade = Range.getGradeByIdFromCache(gradeId);
                var gradeCalculation = calculationData.filter(function (calculationDataItem) {
                  return calculationDataItem.Vehicle.MaterialCode === step.MaterialCode;
                })[0];
                var name = grade.vehicleModel.Name + " " + grade.name;
                var number = difference > 0 ? difference : difference * -1;
                return angular.extend({}, step, {
                  difference: difference,
                  name: name,
                  gradeName: grade.name,
                  number: number,
                  gradeId: gradeId,
                  pricePerWeek: gradeCalculation.PricePerWeek,
                  gfv: gradeCalculation.GFV,
                  fincancing: gradeCalculation,
                  displayStep: true,
                });
              });
          });

          $q.all(modifiedStepData).then(function (results) {
            var orderedSteps = results.sort(function (obj1, obj2) {
              return obj2.difference - obj1.difference;
            });

            $scope.financeCalculator.steps = orderedSteps;

            resetLoading();
          });
        } else {
          resetLoading();
        }
      }

      /**
       * parseDisclaimersToSitecoreDisclaimers - convert disclaimers from Finance API schema to Sitecore, while
       * replacing placeholder text in the disclaimers with the vehicle description schema.
       *
       * @param  {array} financeDisclaimers  array of disclaimers from api
       * @return {object} schema correct disclaimer
       */
      function parseDisclaimersToSitecoreSchema(financeDisclaimers) {
        var titles = "";
        return financeDisclaimers.map(function (financeDisclaimer) {
          // Replace disclaimer strings by matching two groups 1: the [title] at the beginning of the string 2: everything else. then return group 1
          var disclaimerTitle = financeDisclaimer.replace(/^\[(.*)\](.*)$/gi, "$1");
          // Replace disclaimer strings by matching two groups 1: the [title] at the beginning of the string 2: everything else. then return group 2
          var disclaimerDescription = financeDisclaimer.replace(/^\[(.*)\](.*)$/gi, "$2");
          disclaimerDescription = disclaimerDescription.replace(
            "{%FullDescription%}",
            $scope.financeCalculator.vehicleDescription
          );

          var sitecoreDisclaimer = {
            title: disclaimerTitle,
            description: disclaimerDescription,
          };

          titles += disclaimerTitle + " ";

          var reg = new RegExp("\\" + disclaimerTitle, "g");

          if (titles.match(reg).length > 1) {
            angular.extend(sitecoreDisclaimer, { title: disclaimerTitle + titles.match(reg).length });
          }

          angular.extend(sitecoreDisclaimer, { title: "[" + sitecoreDisclaimer.title + "]" });

          return sitecoreDisclaimer;
        });
      }

      /**
       * exportFinanceDisclaimers - replace placeholder text in the disclaimers with details from the vehicle
       * description schema
       *
       * @param  {array} financeDisclaimers array of disclaimers from api
       * @return {void}
       */
      function exportFinanceDisclaimers(financeDisclaimers) {
        var sitecoreDisclaimers = parseDisclaimersToSitecoreSchema(financeDisclaimers);

        $scope.financeOptions.disclaimerTitle = sitecoreDisclaimers[0].title;
        $scope.financeCalculator.disclaimerTitle = sitecoreDisclaimers[0].title;

        DisclaimersService.purgeGroup("finance-calculator");
        DisclaimersService.ingestDisclaimersArrayToGroup(sitecoreDisclaimers, "finance-calculator");
        DisclaimersService.showGroup("finance-calculator");
      }

      /**
       * getSessionStorage - updates the content of the sessionStorage with current data
       * @return {object} current session storage object
       */
      function getSessionStorage() {
        return SessionStorage.get(SESSION_STORAGE_KEY);
      }

      /**
       * removeSessionStorage - remove the content of the sessionStorage
       * @return {boolean} if remove session storage was successful
       */
      function removeSessionStorage() {
        return SessionStorage.remove(SESSION_STORAGE_KEY);
      }

      /**
       * updateSessionStorage - updates the content of the sessionStorage with current data
       *
       * @param  {string} vehicleModel the current vehicle model name
       * @param  {number} loanRate     the calculated loan rate
       * @param  {number} deposit      the selected deposit
       * @param  {number} loanTerm     the loan term
       * @param  {number} kmsPerYear   the kms per year
       * @param  {boolean} isCampaign  if the calculations are part of a campaign
       * @return {void}
       */
      function updateSessionStorage(vehicleModel, loanRate, deposit, loanTerm, kmsPerYear, isCampaign) {
        SessionStorage.set(SESSION_STORAGE_KEY, {
          vehicleModel: vehicleModel,
          loanRate: loanRate,
          deposit: deposit,
          loanTerm: loanTerm,
          kmsPerYear: kmsPerYear,
          isCampaign: isCampaign,
        });
      }
    }

    var link = function ($scope) {
      // setTimeout forces the link functions to the end of the Javascript stack so it runs post angular render
      setTimeout(function () {
        // jQuery variables
        var $calculator = angular.element(".ty-finance-calculator");
        var $modalBody = angular.element(".ty-modal-panel__body");
        var $stickyFooter = angular.element('[data-js="ty-finance-calculator-sticky-footer"]');
        var $anchor = angular.element('[data-js="ty-finance-calculator-anchor"]');

        // Normal variables
        var stickyClass = "is-sticky";
        var supportsCSS = !!((CSS && CSS.supports) || false);
        var supportsSticky =
          supportsCSS && (CSS.supports("position", "sticky") || CSS.supports("position", "-webkit-sticky"));
        var isAnchored = false;
        var anchorY = $anchor.length > 0 ? $anchor.get(0).offsetTop : 0;
        var isSafariIOS = /iP(hone|od).+Version\/[\d.]+.*Safari/i.test(navigator.userAgent);
        var footerOffsetAnimationTimeout = 600;

        /**
         * calculateFooterTop - calculates the distance from the top of the document to the start of the footer
         *
         * @param  {Number} modalHeight  the height of the modal body
         * @param  {Number} scrollTop    the scrollTop of the modal
         * @param  {Number} footerHeight the height of the footer
         * @return {Number}              the distance
         */
        var calculateFooterTop = function (modalHeight, scrollTop, footerHeight) {
          return modalHeight + scrollTop - footerHeight;
        };

        /**
         * updateStickyFooter - updates the position of the footer element for elements that don't support position: sticky, like IE11
         *
         * @return {void}
         */
        var updateStickyFooter = function () {
          var $footerAnchor = angular.element('[data-js="ty-finance-calculator-sticky-footer-anchor"]');
          $stickyFooter = angular.element('[data-js="ty-finance-calculator-sticky-footer"]');
          var modalHeight = $modalBody.height();
          var scrollTop = $modalBody.scrollTop();
          var footerHeight = $stickyFooter.outerHeight();
          var anchorTop = $footerAnchor.get(0).getBoundingClientRect().top + footerHeight;

          if (anchorTop < modalHeight) {
            $stickyFooter.removeClass(stickyClass);
            $stickyFooter.removeAttr("style");
          } else {
            // Set the CSS
            if (!$stickyFooter.hasClass(stickyClass)) {
              $stickyFooter.addClass(stickyClass);
            }

            $stickyFooter.css({
              top: calculateFooterTop(modalHeight, scrollTop, footerHeight) + "px",
            });
          }
        };

        /**
         * updateLoadingOverlayPosition - updates the top position of the loading overlay depending on where the user has scrolled to
         *
         * @return {void}  description
         */
        var updateLoadingOverlayPosition = function () {
          var scrollTop = $modalBody.scrollTop();
          var $loadingOverlay = angular.element(".ty-finance-calculator__loading");
          $loadingOverlay.css({
            top: scrollTop + "px",
          });

          isAnchored = scrollTop > anchorY;
        };

        /**
         * anchorOnClick - Scrolls the user down when they click on a control field
         *
         * @return {void}
         */
        var anchorOnClick = function () {
          if (!isAnchored) {
            $modalBody.animate(
              {
                scrollTop: anchorY,
              },
              MODAL_SCROLL_DURATION_MS
            );
            isAnchored = true;
          }
        };

        /**
         * adjustStickyFooterForIOS - this is a hack to keep the footer positioned at the bottom, depending on whether or not toolbars/address bar
         *                            is visible. ideally this should be removed once position: sticky starts to work consistently cross browser
         *                            and cross device
         *
         * @return {void}
         */
        var adjustStickyFooterForIOS = function () {
          // If the footer is offset (i.e. hidden) or we're not in Safari IOS then we don't want to modify the styles
          if ($stickyFooter.hasClass("is-offset") || !isSafariIOS) {
            return;
          }

          // original fix was breaking the sticky nature in iphone; setting this to 0px
          $stickyFooter.css("bottom", "0");
        };

        /**
         * resetTopScroll - scroll the modal body back to the top
         *
         * @return {void}
         */
        var resetTopScroll = function () {
          $modalBody.scrollTop(0);
        };

        /**
         * addFooterOffset - hides the footer so it is ready to be animated up when the user opens the modal
         *
         * @return {void}
         */
        var addFooterOffset = function () {
          setTimeout(function () {
            $stickyFooter.addClass("is-offset");
          }, footerOffsetAnimationTimeout);
        };

        /**
         * removeFooterOffset - removes the is-offset class, which will animate the footer into view when the user opens the modal
         *
         * @return {void}
         */
        var removeFooterOffset = function () {
          setTimeout(function () {
            $stickyFooter.removeClass("is-offset");
          }, footerOffsetAnimationTimeout);
        };

        /**
         * resetInlineFooterStyles - removes the style property from the sticky footer when the user closes the modal
         *
         * @return {void}
         */
        var resetInlineFooterStyles = function () {
          $stickyFooter.removeProp("style");
        };

        // Event listener for the control fields
        $anchor.on("click", anchorOnClick);
        $modalBody.on("scroll", updateLoadingOverlayPosition);

        // Event listener for the modal-open event
        $scope.$on("modal-open", function () {
          resetTopScroll();
          removeFooterOffset();

          // Delay adjusting the footer to allow for the modal to fade in/scale up
          setTimeout(function () {
            adjustStickyFooterForIOS();
          }, footerOffsetAnimationTimeout);
        });

        // Listener for the modal-close event
        $scope.$on("modal-close", function () {
          addFooterOffset();
          resetInlineFooterStyles();
        });

        // Listener for modal-exit event - similar to modal-close, but only fired when the user clicks the close button or the overlay
        $scope.$on("modal-exit", function (event, modalId) {
          if (modalId === "finance-calculator") {
            $scope.financeCalculator.track("calc complete", "close", { calcComplete: 1, calcInteraction: 0 });
          }
        });

        // Window event listeners
        angular.element(window).on("resize", adjustStickyFooterForIOS);
        angular.element(window).on("resize orientationChange", updateLoadingOverlayPosition);

        // If the browser doesn't support position: sticky, add the event handlers to update the footer position
        if (!supportsSticky) {
          $modalBody.on("scroll resize orientationChange", updateStickyFooter);
          $scope.$on("modal-open", updateStickyFooter);
        } else {
          $calculator.addClass("has-sticky-support");
        }

        // Set the dial element/wrapper values
        $scope.financeCalculator.dialElement = angular.element(".ty-rslider__target");
        $scope.financeCalculator.dialWrapper = angular.element(".ty-rslider");
      }, 0);
    };

    return {
      scope: false,
      restrict: "A",
      controller: controller,
      bindToController: {
        messageTemplate: "@tyFinanceCalculatorMessageTemplate",
      },
      controllerAs: "financeCalculatorController",
      link: link,
    };
  });
})(window.angular, window.setTimeout, window.parseFloat, window.CSS, window.ToyotaConsts);
